export interface ITransformConfig {
  path: string[];
}

export interface IReducerConfig {
  reducerName: string;
  reducer: any;
  transformation?: ITransformConfig;
  persistLocally?: boolean;
}

class ReduxPartsBuilder {
  public constructor() {
    this.reducers = [];
    this.sagas = [];
  }

  private reducers: IReducerConfig[];
  private sagas: any[];

  public append(reducer: IReducerConfig, saga: any): ReduxPartsBuilder {
    if (reducer) {
      this.reducers = [...this.reducers, reducer];
    }
    if (saga) {
      this.sagas = [...this.sagas, saga];
    }

    return this;
  }

  public appendMultiple(reducers: IReducerConfig[], sagas: any[]): ReduxPartsBuilder {
    if (reducers) {
      this.reducers = [...this.reducers, ...reducers];
    }
    if (sagas) {
      this.sagas = [...this.sagas, ...sagas];
    }

    return this;
  }

  public getReducers() {
    return this.reducers;
  }

  public getSagas() {
    return this.sagas;
  }
}

const reduxPartsBuilder = new ReduxPartsBuilder();

export const appendReduxParts = (reducers: IReducerConfig[], sagas: any[]): ReduxPartsBuilder => {
  reduxPartsBuilder.appendMultiple(reducers, sagas);

  return reduxPartsBuilder;
};

export const appendReduxPart = (reducer: IReducerConfig, saga: any): ReduxPartsBuilder => {
  reduxPartsBuilder.append(reducer, saga);

  return reduxPartsBuilder;
};

export const getReduxPartsBuilder = (): ReduxPartsBuilder => {
  return reduxPartsBuilder;
};
